import { render, staticRenderFns } from "./BasicInfoEdit.vue?vue&type=template&id=4e6db14a"
import script from "./BasicInfoEdit.vue?vue&type=script&lang=js"
export * from "./BasicInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports